/* eslint-disable eqeqeq */
import { PureComponent } from 'react';
import greenRight from '../assets/green-right.svg';
import profileIcon from '../assets/right-content-profile.svg';
import { Trans, withTranslation } from 'react-i18next';

class SignInContentBase extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    return (
      <div className="sign-in">
        <div className="container">
          <label className={'leftSideContent'}>
            <Trans
              i18nKey="auth.signin.tagline"
              components={{ orange: <span className="orangeText" /> }}
            />
          </label>

          <div className={'middleContent'}>
            <div className="heading-content">
              <label className="takso-definition">
                <Trans
                  i18nKey="auth.signin.takso_definition.intro"
                  components={{ orange: <span className="orangeText" /> }}
                />
              </label>
            </div>
            <img alt="greenRight" src={greenRight} />{' '}
            <label className={'list'}>
              <Trans
                i18nKey="auth.signin.takso_definition.1"
                components={{ bold: <span className="bold" /> }}
              />
            </label>
            <br></br>
            <img alt="greenRight" src={greenRight} />{' '}
            <label className={'list'}>
              <Trans
                i18nKey="auth.signin.takso_definition.2"
                components={{ bold: <span className="bold" /> }}
              />
            </label>
            <br></br>
            <img alt="greenRight" src={greenRight} />{' '}
            <label className={'list'}>
              <Trans
                i18nKey="auth.signin.takso_definition.3"
                components={{ bold: <span className="bold" /> }}
              />
            </label>
            <br></br>
            <img alt="greenRight" src={greenRight} />{' '}
            <label className={'list'}>
              <Trans
                i18nKey="auth.signin.takso_definition.4"
                components={{ bold: <span className="bold" /> }}
              />
            </label>
            <br></br>
            <img alt="greenRight" src={greenRight} />{' '}
            <label className={'list'}>
              <Trans
                i18nKey="auth.signin.takso_definition.5"
                components={{ bold: <span className="bold" /> }}
              />
            </label>
            <br></br>
            <img alt="greenRight" src={greenRight} />{' '}
            <label className={'list'}>
              <Trans
                i18nKey="auth.signin.takso_definition.6"
                components={{ bold: <span className="bold" /> }}
              />
            </label>
            <br></br>
            <img alt="greenRight" src={greenRight} />{' '}
            <label className={'list'}>
              <Trans
                i18nKey="auth.signin.takso_definition.7"
                components={{ bold: <span className="bold" /> }}
              />
            </label>
          </div>
        </div>
      </div>
    );
  }
}
export const SignInContent = withTranslation()(SignInContentBase);

class SignUpContent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className="container">
          <label className={'leftSideContent'}>
            <Trans
              i18nKey="auth.sign_up.good_news"
              components={{ orange: <span className="orangeText" /> }}
            />
          </label>
          <div className={'middleContent'}>
            <img alt="profileImg" className={'profileImg'} src={profileIcon} />{' '}
            <br></br>
            <label className={'quoteText'}>
              {t('auth.sign_up.quote_text')}
            </label>
            <br></br>
            <label className={'quoteName'}>
              {t('auth.sign_up.quote_name')}
            </label>
            <br></br>
            <label className={'quoteNameSub'}>
              {t('auth.sign_up.quote_name_sub')}
            </label>
          </div>
        </div>
      </div>
    );
  }
}
SignUpContent = withTranslation()(SignUpContent);
export { SignUpContent };
